<template>
  <main :class="view == 'list' ? 'usuariosPainel' : 'usuariosSeletor'">
    <header v-if="view == 'list'" class="usuariosCabecalho">
      <div>
        <p class="usuariosEyebrow">Gestão de acesso</p>
        <h1>Usuários</h1>
        <p>Consulte cadastros, perfis, sites e vencimentos.</p>
      </div>
      <div class="usuariosCabecalhoAcoes">
        <span class="usuariosTotal">
          <strong>{{ itensTotal }}</strong>
          <small>cadastros</small>
        </span>
        <button type="button" class="usuariosNovo" @click="itemNovo()">
          <i class="fa fa-plus" aria-hidden="true"></i>
          Novo usuário
        </button>
      </div>
    </header>

    <section v-if="view == 'select'" class="usuariosSelecaoCabecalho">
      <div v-if="selectItem == null && !viewUserEdit">
        <strong>Selecione ou crie um usuário</strong>
        <button type="button" class="usuariosNovo" @click="itemNovo()">
          <i class="fa fa-plus" aria-hidden="true"></i>
          Novo usuário
        </button>
      </div>
      <button
        v-if="selectItem !== null && !viewUserEdit"
        type="button"
        class="usuariosSecundario"
        @click="editarItem(null)"
      >
        Trocar usuário
      </button>
      <button
        v-if="viewUserEdit"
        type="button"
        class="usuariosSecundario"
        @click="viewUserEdit = false"
      >
        Selecionar usuário
      </button>
    </section>

    <div :class="{ 'd-none': view == 'select' && viewUserEdit }">
      <section v-if="selectItem == null" class="usuariosFerramentas">
        <div class="usuariosFiltros">
          <label
            v-if="
              retornaSite() !== '7live' &&
              retornaSite() !== 'Share' &&
              retornaSite() !== 'Stream1x2'
            "
            class="usuariosFiltro usuariosFiltroSite"
          >
            <span>Site</span>
            <Combo
              :itens="$global.sites_filtro()"
              v-model="filtroSite"
              @change="carregarItens"
            />
          </label>

          <label class="usuariosPesquisa">
            <i class="fa fa-search" aria-hidden="true"></i>
            <input
              v-model="filtroTexto"
              type="text"
              placeholder="Pesquisar por nome ou e-mail"
              autocomplete="off"
              @keyup="keyupFiltroTexto"
            />
          </label>

          <label
            v-if="retornaSite() !== '7live'"
            class="usuariosFiltro usuariosFiltroOrdem"
          >
            <span>Ordenar</span>
            <Combo
              :itens="ordemOpcoes"
              v-model="ordem"
              @change="carregarItens"
            />
          </label>
        </div>

        <nav
          v-if="retornaSite() !== '7live' && view == 'list'"
          class="usuariosTipos"
          aria-label="Tipos de usuário"
        >
          <button
            type="button"
            :class="{ ativo: filtroTipoUsuario == 'Todos' }"
            @click="filtrarTipo('Todos')"
          >
            Todos
          </button>
          <button
            v-for="tipoUsuario in $global.tipos_usuarios()"
            :key="tipoUsuario.id"
            type="button"
            :class="{ ativo: filtroTipoUsuario == tipoUsuario.id }"
            @click="filtrarTipo(tipoUsuario.id)"
          >
            {{ tipoUsuario.nome }}
          </button>
        </nav>
      </section>

      <section class="usuariosLista" aria-label="Lista de usuários">
        <button
          v-for="item in itens"
          v-show="selectItem == null || selectItem == item._id"
          :key="item._id"
          type="button"
          class="usuarioLinha"
          :data-toggle="view == 'list' ? 'modal' : ''"
          :data-target="view == 'list' ? '#dialogEdit' : ''"
          @click="editarItem(item._id)"
        >
          <span class="usuarioAvatar">{{ iniciaisUsuario(item) }}</span>
          <span class="usuarioIdentidade">
            <strong>{{ nomeUsuario(item) }}</strong>
            <small>{{ item.email }}</small>
            <small v-if="item.indicacao" class="usuarioIndicacao">
              Indicação: {{ item.indicacao.email }}
            </small>
          </span>
          <span class="usuarioClassificacao">
            <span v-if="item.site" class="usuarioSite">{{ item.site }}</span>
            <span class="usuarioTipo">{{ nomeTipoUsuario(item) }}</span>
          </span>
          <span class="usuarioDatas">
            <small>Vencimento</small>
            <strong>{{ vencimentoUsuario(item) }}</strong>
            <span v-if="retornaSite() == 'Weddbets'">
              Cadastro {{ formatDateTime(item.dataCadastro) }}
            </span>
          </span>
          <i class="fa fa-angle-right usuarioAbrir" aria-hidden="true"></i>
        </button>

        <div v-if="itens.length == 0" class="usuariosVazio">
          <i class="fa fa-user-o" aria-hidden="true"></i>
          <span>Nenhum usuário encontrado</span>
        </div>
      </section>

      <div
        :class="{
          'd-none': view == 'select' && selectItem != null && !viewUserEdit,
        }"
        class="usuariosPaginacao"
      >
        <Paginacao
          ref="paginacao"
          :total="itensTotal"
          :limit="itensLimit"
          @change-pagina="carregarItens"
        />
      </div>
    </div>

    <EditUsuario
      ref="editItem"
      @save-item="salvouUsuario"
      :propView="view == 'select' ? 'document' : 'modal'"
      :class="{ 'd-none': view == 'select' && !viewUserEdit }"
    />
  </main>
</template>

<script>
import { api } from "@/services/api.js";
import util from "../includes/util.js";

import EditUsuario from "../edits/EditUsuario.vue";

import Paginacao from "../components/Paginacao.vue";
import Combo from "../components/Combo.vue";

export default {
  name: "ListUsuarios",
  components: { EditUsuario, Paginacao, Combo },
  props: { itensLimit: { type: Number, default: 50 }, view: { type: String, default: "list" } },
  methods: {
    filtrarTipo(tipo) {
      this.filtroTipoUsuario = tipo;

      if (this.$refs.paginacao) {
        this.$refs.paginacao.pagina = 1;
      }

      this.carregarItens();
    },
    nomeTipoUsuario(item) {
      const tipos = this.$global.tipos_usuarios_index();
      return tipos[item.tipoUsuario] ? tipos[item.tipoUsuario].nome : item.tipoUsuario;
    },
    nomeUsuario(item) {
      return this.retornaSite() == "7live"
        ? item.email
        : item.nome || item.email;
    },
    iniciaisUsuario(item) {
      const nome = this.nomeUsuario(item) || "U";
      const partes = nome.trim().split(/\s+/).filter(Boolean);

      return partes
        .slice(0, 2)
        .map((parte) => parte.charAt(0).toUpperCase())
        .join("");
    },
    vencimentoUsuario(item) {
      if (item.idx_planosUltimo) {
        let vencimento = item.idx_planosCorrente
          ? this.formatDate(item.idx_planosCorrente.dataFim)
          : this.formatDate(item.idx_planosUltimo.dataFim);

        if (item.idx_planosProximo && item.idx_planosProximo.length > 0) {
          vencimento +=
            " ... " +
            this.formatDate(
              item.idx_planosProximo[item.idx_planosProximo.length - 1].dataFim
            );
        }

        return vencimento;
      }

      return this.formatDate(item.vencimento);
    },
    retornaSite() {
      return this.$site;
    },
    async carregarItens() {
      var filtros = "";

      if (this.retornaSite() == "7live") {
        this.ordem = "email_ASC";
      }

      filtros +=
        "?_limit=" + this.itensLimit + "&_page=" + this.$refs.paginacao.pagina;

      if (this.filtroTexto !== "") {
        filtros += "&_all=" + this.filtroTexto;
      }

      if (this.filtroSite !== "Todos") {
        filtros += "&site=" + this.filtroSite;
      }

      if (this.filtroTipoUsuario !== "Todos") {
        filtros += "&tipoUsuario=" + this.filtroTipoUsuario;
      }

      filtros += "&_ordem=" + this.ordem;

      const response = await api.get("/usuario" + filtros);
      api.valid(response.data, this.$router);

      this.itens = response.data.itens;
      this.itensTotal = response.data.total;
    },
    editarItem(id) {

      if (this.view == "select") {
        this.selectItem = this.selectItem == null ? id : null;
        this.$emit("selectItemChange", this.selectItem);
      } else {
        this.$refs.editItem.carregarItem(id);
      }

    },
    itemNovo() {

      this.$refs.editItem.novo();

      if (this.view == "select") {
        this.viewUserEdit = true;
      } else {

        this.$refs.editItem.abrir();
      }

    },
    salvouUsuario(itemUsuario) {

      if (this.view == "select") {

        this.filtroTexto = itemUsuario.email;
        this.filtroSite = "Todos";
        this.filtroTipoUsuario = "Todos";
        this.ordem = "dataCadastro_DESC";
        this.viewUserEdit = false;
        this.carregarItens();

        this.editarItem(itemUsuario._id);

      } else {

        this.carregarItens();
      }

    },
    keyupFiltroTexto() {
      clearTimeout(this.timerFiltroTexto);

      var obj = this;

      this.timerFiltroTexto = setTimeout(function () {
        obj.$refs.paginacao.pagina = 1;
        obj.carregarItens();
      }, 300);
    },
    formatDate(data) {
      if (!data || data == "-") {
        return "-";
      }
      return util.formatDate(data);
    },
    formatDateTime(data) {
      if (!data || data == "-") {
        return "-";
      }
      return util.formatDateTime(data);
    },
    limpar() {

      this.filtroTexto = "";
      this.filtroSite = "Todos";
      this.filtroTipoUsuario = "Todos";
      this.ordem = "dataCadastro_DESC";
      this.itens = [];
      this.itensTotal = 0;
      this.editItem = null;
      this.selectItem = null;
      this.viewUserEdit = false;
      this.carregarItens();

    }
  },
  mounted() {
    if (this.retornaSite() == "Weddbets") {
      this.ordem = "dataCadastro_DESC";
    }
    this.carregarItens();
  },
  data: function () {
    return {
      filtroTexto: "",
      filtroSite: "Todos",
      filtroTipoUsuario: "Todos",
      ordem: "vencimento_ASC",
      itens: [],
      itensTotal: 0,
      editItem: null,
      selectItem: null,
      viewUserEdit: false
    };
  },
  computed: {
    ordemOpcoes() {
      const vencimentoPrefixo =
        this.retornaSite() == "Weddbets" ? "tempVencimento" : "vencimento";

      return [
        { id: vencimentoPrefixo + "_ASC", nome: "Vencimento ASC" },
        { id: vencimentoPrefixo + "_DESC", nome: "Vencimento DESC" },
        { id: "nome_ASC", nome: "Nome ASC" },
        { id: "nome_DESC", nome: "Nome DESC" },
        { id: "email_ASC", nome: "Email ASC" },
        { id: "email_DESC", nome: "Email DESC" },
        { id: "dataCadastro_ASC", nome: "Cadastro ASC" },
        { id: "dataCadastro_DESC", nome: "Cadastro DESC" },
      ];
    },
  },
};
</script>

<style>
.usuariosPainel {
  margin: 0 auto;
  max-width: 1180px;
  padding: 26px 16px 48px;
  text-align: left;
}

.usuariosSeletor {
  padding: 12px 0;
}

.usuariosCabecalho {
  align-items: flex-end;
  border-bottom: 1px solid #dfe3e6;
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
  padding: 0 2px 15px;
}

.usuariosEyebrow {
  color: #65717a;
  font-size: 10px;
  font-weight: 700;
  margin: 0 0 4px;
  text-transform: uppercase;
}

.usuariosCabecalho h1 {
  color: #242a2f;
  font-size: 26px;
  font-weight: 600;
  line-height: 1.1;
  margin: 0;
}

.usuariosCabecalho p:not(.usuariosEyebrow) {
  color: #6f7880;
  font-size: 11px;
  margin: 6px 0 0;
}

.usuariosCabecalhoAcoes,
.usuariosSelecaoCabecalho > div {
  align-items: center;
  display: flex;
  gap: 12px;
}

.usuariosTotal {
  border-right: 1px solid #dfe3e6;
  display: flex;
  flex-direction: column;
  padding-right: 14px;
  text-align: right;
}

.usuariosTotal strong {
  color: #30373d;
  font-size: 20px;
  line-height: 1;
}

.usuariosTotal small {
  color: #788188;
  font-size: 9px;
  margin-top: 3px;
}

.usuariosNovo,
.usuariosSecundario {
  align-items: center;
  border-radius: 3px;
  display: inline-flex;
  font-size: 11px;
  font-weight: 600;
  gap: 6px;
  height: 32px;
  justify-content: center;
  padding: 0 11px;
}

.usuariosNovo {
  background: #0d6efd;
  border: 1px solid #0d6efd;
  color: #ffffff;
}

.usuariosSecundario {
  background: #ffffff;
  border: 1px solid #9ca5ac;
  color: #414950;
}

.usuariosSelecaoCabecalho {
  border-bottom: 1px solid #dfe3e6;
  margin-bottom: 12px;
  padding-bottom: 12px;
}

.usuariosFerramentas {
  background: #f7f8f9;
  border-bottom: 1px solid #dfe3e6;
  border-top: 1px solid #dfe3e6;
  margin-bottom: 14px;
  padding: 12px 14px 9px;
}

.usuariosFiltros {
  align-items: center;
  display: flex;
  gap: 8px;
}

.usuariosFiltro,
.usuariosPesquisa {
  align-items: center;
  background: #ffffff;
  border: 1px solid #cdd3d8;
  display: flex;
  height: 34px;
  margin: 0;
}

.usuariosFiltro > span {
  color: #707981;
  font-size: 10px;
  padding: 0 8px;
  white-space: nowrap;
}

.usuariosFiltro .form-control {
  border: 0;
  border-left: 1px solid #e2e6e9;
  border-radius: 0;
  box-shadow: none;
  font-size: 11px;
  height: 32px;
  min-width: 110px;
}

.usuariosFiltroSite {
  flex: 0 0 205px;
}

.usuariosFiltroOrdem {
  flex: 0 0 235px;
}

.usuariosPesquisa {
  flex: 1 1 320px;
  padding: 0 10px;
}

.usuariosPesquisa .fa {
  color: #858e95;
  font-size: 12px;
  margin-right: 8px;
}

.usuariosPesquisa input {
  border: 0;
  color: #343b41;
  font-size: 12px;
  min-width: 0;
  outline: 0;
  width: 100%;
}

.usuariosPesquisa:focus-within,
.usuariosFiltro:focus-within {
  border-color: #7f9cb8;
  box-shadow: 0 0 0 2px rgba(48, 68, 92, 0.1);
}

.usuariosTipos {
  display: flex;
  gap: 2px;
  margin-top: 9px;
  overflow-x: auto;
  padding-bottom: 1px;
}

.usuariosTipos button {
  background: transparent;
  border: 0;
  border-bottom: 2px solid transparent;
  color: #6b747b;
  flex: 0 0 auto;
  font-size: 10px;
  height: 27px;
  padding: 0 9px;
  white-space: nowrap;
}

.usuariosTipos button.ativo {
  border-bottom-color: #e3ad55;
  color: #293138;
  font-weight: 700;
}

.usuariosLista {
  border-bottom: 1px solid #dfe3e6;
  border-top: 1px solid #dfe3e6;
}

.usuarioLinha {
  align-items: center;
  background: #ffffff;
  border: 0;
  border-bottom: 1px solid #e5e8ea;
  color: #333a40;
  display: grid;
  gap: 12px;
  grid-template-columns: 36px minmax(210px, 1.5fr) minmax(160px, 1fr) minmax(190px, 1fr) 18px;
  min-height: 67px;
  padding: 9px 12px;
  text-align: left;
  width: 100%;
}

.usuarioLinha:last-child {
  border-bottom: 0;
}

.usuarioLinha:hover {
  background: #f7f9fa;
}

.usuarioAvatar {
  align-items: center;
  background: #e7ebee;
  border: 1px solid #d5dade;
  border-radius: 50%;
  color: #4e5962;
  display: flex;
  font-size: 10px;
  font-weight: 700;
  height: 34px;
  justify-content: center;
  width: 34px;
}

.usuarioIdentidade,
.usuarioClassificacao,
.usuarioDatas {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.usuarioIdentidade strong {
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.usuarioIdentidade small,
.usuarioDatas span {
  color: #727b82;
  font-size: 9px;
  margin-top: 3px;
}

.usuarioIndicacao {
  color: #a34b4b !important;
}

.usuarioClassificacao {
  align-items: flex-start;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 5px;
}

.usuarioSite,
.usuarioTipo {
  border: 1px solid #d5dade;
  border-radius: 2px;
  color: #4f5961;
  font-size: 9px;
  padding: 3px 6px;
}

.usuarioSite {
  background: #f1f4f6;
}

.usuarioTipo {
  background: #ffffff;
}

.usuarioDatas {
  align-items: flex-end;
  text-align: right;
}

.usuarioDatas small {
  color: #7b848b;
  font-size: 9px;
}

.usuarioDatas strong {
  font-size: 11px;
  margin-top: 2px;
}

.usuarioAbrir {
  color: #8b949b;
  font-size: 15px;
  text-align: right;
}

.usuariosVazio {
  align-items: center;
  color: #7b848b;
  display: flex;
  flex-direction: column;
  font-size: 11px;
  gap: 7px;
  padding: 36px 12px;
}

.usuariosVazio .fa {
  font-size: 20px;
}

.usuariosPaginacao {
  margin-top: 15px;
}

@media (max-width: 767px) {
  .usuariosPainel {
    padding: 18px 8px 36px;
  }

  .usuariosCabecalho {
    align-items: flex-start;
  }

  .usuariosCabecalho h1 {
    font-size: 22px;
  }

  .usuariosTotal {
    display: none;
  }

  .usuariosFiltros {
    align-items: stretch;
    flex-direction: column;
  }

  .usuariosFiltroSite,
  .usuariosFiltroOrdem,
  .usuariosPesquisa {
    flex-basis: auto;
    width: 100%;
  }

  .usuarioLinha {
    gap: 7px 10px;
    grid-template-columns: 34px minmax(0, 1fr) 16px;
  }

  .usuarioIdentidade {
    grid-column: 2;
  }

  .usuarioClassificacao {
    grid-column: 2;
  }

  .usuarioDatas {
    align-items: flex-start;
    grid-column: 2;
    text-align: left;
  }

  .usuarioAbrir {
    grid-column: 3;
    grid-row: 1 / span 3;
  }
}
</style>
